import PromoImageWeeklyDemo from "./images/promo-card-live-weekly-demo.png";
import Resource from "./images/icon-resource.svg";
import Blog from "./images/icon-blog.svg";
import Learn from "./images/icon-learn.svg";

export default {
  buttons: [
    {
      label: "Sign in",
      type: "secondary",
      url: "https://app.mode.com/signin"
    },
    {
      label: "Try for free",
      type: "primary",
      url: "https://app.mode.com/signup/"
    }
  ],
  links: [
    {
      type: "internalLink",
      label: "Help & Support",
      url: "https://mode.com/help/"
    },
    {
      type: "externalLink",
      label: "Developer",
      url: "https://mode.com/developer/api-reference/introduction/"
    },
    {
      type: "externalLink",
      label: "Contact Support",
      url: "https://mode.com/help/articles/contact-us/"
    },
    {
      type: "dropdownLink",
      label: "Resources",
      lists: [
        {
          type: "linkList",
          links: [
            {
              type: "navBlock",
              heading: "Resource Center",
              icon: {
                type: "image",
                asset: Resource
              },
              primaryLink: [
                {
                  type: "externalLink",
                  label: "Resource Center",
                  url: "https://mode.com/resources/"
                }
              ],
              subLinks: [
                {
                  type: "externalLink",
                  label: "Modern BI Tool Kit",
                  url: "https://mode.com/toolkits/modern-business-intelligence"
                },
                {
                  type: "externalLink",
                  label: "Help Center",
                  url: "https://mode.com/help/"
                },
                {
                  type: "externalLink",
                  label: "Developer Hub",
                  url: "https://mode.com/developer/api-reference/introduction/"
                }
              ],
              subheading: "The data scientist toolbox"
            },
            {
              type: "navBlock",
              heading: "Our Blog",
              icon: {
                type: "image",
                asset: Blog
              },
              primaryLink: [
                {
                  type: "externalLink",
                  label: "Our Blog",
                  url: "https://mode.com/blog/"
                }
              ],
              subLinks: [
                {
                  type: "externalLink",
                  label: "Analysis",
                  url: "https://mode.com/blog/category/analysis"
                },
                {
                  type: "externalLink",
                  label: "News and Updates",
                  url: "https://mode.com/blog/category/general"
                },
                {
                  type: "externalLink",
                  label: "Visualization",
                  url: "https://mode.com/blog/category/visualization"
                }
              ],
              subheading: "Data insights for everyone"
            },
            {
              type: "navBlock",
              heading: "Learn SQL",
              icon: {
                type: "image",
                asset: Learn
              },
              primaryLink: [
                {
                  type: "externalLink",
                  label: "Learn SQL",
                  url: "https://mode.com/sql-tutorial/"
                }
              ],
              subheading: "Answer data questions with SQL"
            },
            {
              type: "navBlock",
              heading: "Learn Python",
              icon: {
                type: "image",
                asset: Learn
              },
              primaryLink: [
                {
                  type: "externalLink",
                  label: "Learn Python",
                  url: "https://mode.com/python-tutorial/"
                }
              ],
              subheading: "Analyze business data with Python"
            }
          ]
        },
        {
          type: "linkList",
          heading: "Additional Resources",
          links: [
            {
              type: "internalLink",
              label: "System status",
              url: "https://status.modeanalytics.com/"
            },
            {
              type: "internalLink",
              label: "Report themes",
              url: "https://mode.com/report-themes/"
            },
            {
              type: "internalLink",
              label: "Mode University",
              url: "https://university.mode.com/"
            },
            {
              type: "internalLink",
              label: "Example gallery",
              url: "https://mode.com/example-gallery/"
            },
            {
              type: "internalLink",
              label: "Playbooks",
              url:
                "https://mode.com/help/articles/how-to-use-the-mode-playbook/"
            },
            {
              type: "internalLink",
              label: "Visual Explorer Field Guides",
              url: "https://mode.com/visual-explorer-guides/"
            }
          ]
        }
      ],
      promoEyebrow: "Live demo",
      promoHeading: "Get a firsthand look at Mode's key features & workflows",
      promoImage: {
        type: "image",
        asset: PromoImageWeeklyDemo
      },
      promoLink: [
        {
          type: "externalLink",
          label: "Save your seat",
          url:
            "https://events.mode.com/meet-mode"
        }
      ],
      title: "Resources"
    },
    {
      type: "externalLink",
      label: "Events",
      url: "https://mode.com/help/events/"
    }
  ]
};
